module.exports = __webpack_public_path__ + "static/media/imgpsh_fullsize_anim .edeffb7c.png";